import React from 'react';
import AreaTitle from '../AreaTitle';
import FundingModel from '../FundingModel';
import Graph from '../Graph';
import CalculatePayments from "../calculation/Calculation.js";

class Funding extends React.Component {
  componentDidMount() {
    if(!this.props.state.sidePanelSections.variables.open) {
      let sidePanelSections = {
        variables: Object.assign({}, this.props.state.sidePanelSections.variables, {open:true})
      }
      sidePanelSections = Object.assign({}, this.props.state.sidePanelSections, sidePanelSections);
      this.props.updateState({
        sidePanelSections: sidePanelSections
      });
    }
    this.props.updateState({
      phase: 2
    });
  }

  render() {
    let state = this.props.state;
    let graphs = state.availableFundingModels
                     .map(m => CalculatePayments(m.slug, m.title, state.investmentSize, state.payBackTime, state.completionYear,
                                                 state.varsLoanInterest, state.varsGreenLoanInterest, state.varsLeasingInterest,
                                                 state.varsLeasingResidualValue, state.varsGreenLeasingInterest,
                                                 state.varsGreenLeasingResidualValue, state.varsLongRentInitialRent,
                                                 state.varsLongRentIndexing, state.varsLongRentRedemptionValue,
                                                 state.varsShortRentInitialRent, state.varsShortRentIndexing,
                                                 state.varsShortRentRedemptionValue, state.varsLeasingContractTime,
                                                 state.varsGreenLeasingContractTime));
    let cheapest = graphs.reduce((min, g) => g.sum < min[1] ? [g.title, g.sum] : min, [graphs[0].title, graphs[0].sum]);
    let firstYear = graphs.map(g => [g.title, g.years[1].sum]);
    let sum = graphs.map(g => [g.title, g.sum]);
    return (
      <div className="view-content">
        <AreaTitle text="Valitse 1-3 rahoitusmallia"/>
        <div className="card-wrapper">
          <div className="card not-selectable">
            Rahoitusajan pituus vaikuttaa pääomakustannuksiin. Takapainoinen maksuprofiili keventää ensimmäisten vuosien pääomakustannuksia. Voit arvioida hankkeeseesi sopivia vuotuisia pääomakustannuksia laskurin tietoja päivittämällä.
          </div>
        </div>
        <div className="graph-container">
          <div className="graph left">
            <Graph title="Pääomakustannukset" data={sum} />
          </div>
          <div className="graph right">
            <Graph title="Vuosikustannukset (1. vuosi)" data={firstYear} />
          </div>
        </div>
        {this.props.state.availableFundingModels.map((model, key) =>
          <FundingModel key={model.slug} state={this.props.state} model={model}
                        isCheapest={cheapest[0] === model.title} updateState={this.props.updateState}
                        selected={this.props.state.selectedFundings.includes(model.slug)} />
        )}
      </div>
    );
  }
}

export default Funding;
